import { useDispatch, useSelector } from 'react-redux';
import { WidgetID } from '../../../models/widget.model';
import { selectWidgetFilters, setWidgetFilter } from '../../../store/slices/widget-filter.slice';
import { selectPagination, setPagination } from '../../../store/slices/pagination.slice';
import { useCallback } from 'react';
import { isColumnMenuFilterActive, GridFilterChangeEvent } from '@progress/kendo-react-grid';
import { RootState } from '../../../store';
import { CompositeFilterDescriptor, State } from '@progress/kendo-data-query';

export function useGridWithFiltering(id: WidgetID) {
  const dispatch = useDispatch();
  const filter = useSelector((state: RootState) => selectWidgetFilters(state, id));
  const paging = useSelector((state: RootState) => selectPagination(state, id));

  const onColumnFilter = useCallback(
    (e: GridFilterChangeEvent) => {
      const gridFilters = e.filter;

      dispatch(
        setWidgetFilter({
          id: id,
          filters: gridFilters ? [gridFilters] : [],
        })
      );

      // Reset pagination to first page when filters change
      if (paging && paging.skip !== 0) {
        dispatch(
          setPagination({
            id: id,
            skip: 0,
            take: paging.take,
            total: paging.total,
          })
        );
      }
    },
    [dispatch, id, paging]
  );

  const isColumnFiltered = (field: string, dataState: State) => {
    return isColumnMenuFilterActive(field, dataState.filter);
  };

  const returnFilter = filter.length > 0 ? (filter[0] as CompositeFilterDescriptor) : undefined;

  return { filter: returnFilter, onColumnFilter, isColumnFiltered };
}
